import { MouseEvent, useContext, useState } from 'react';

import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';

import { AppContext } from '../App/appReducer';
import { AppActionKind, DuplicateWorkflow } from '../App/types';
import LandingDynamicWorkflow from './landingDynamicWorkflow';

export default ({ workflowInfo }: { workflowInfo: LandingDynamicWorkflow }) => {
  const { dispatch } = useContext(AppContext);

  const [kebabAnchorEl, setKebabAnchorEl] = useState<HTMLButtonElement | null>(
    null
  );
  const isKebabPopoverOpen = Boolean(kebabAnchorEl);

  const handleKebabClick = (event: MouseEvent<HTMLButtonElement>) => {
    setKebabAnchorEl(isKebabPopoverOpen ? null : event.currentTarget);
  };

  const handleClose = () => {
    setKebabAnchorEl(null);
  };

  const handleDuplicateClick = () => {
    dispatch({
      type: AppActionKind.SET_DUPLICATE_WORKFLOW,
      payload: {
        workflowId: workflowInfo.id,
        workflowName: workflowInfo.name,
        workflowType: workflowInfo.workflowType
      } as DuplicateWorkflow
    });
  };

  return (
    <>
      <IconButton aria-label="More" onClick={handleKebabClick}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={isKebabPopoverOpen}
        anchorEl={kebabAnchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <List>
          <ListItemButton
            sx={{ paddingLeft: '0px', paddingRight: '15px' }}
            onClick={handleDuplicateClick}
          >
            <ListItemIcon>
              <FileCopyIcon
                sx={{
                  paddingLeft: '15px',
                  fontSize: '20px'
                }}
              />
            </ListItemIcon>
            <ListItemText primary={'Duplicate'} />
          </ListItemButton>
        </List>
      </Popover>
    </>
  );
};
